const state = () => ({
  wineClubPreselectedPlan: null,
  membershipTypes: [],
  membershipPlanSlugToName: {},
  productsToMemberships: {},
})

const mutations = {
  SET_WINE_CLUB_PRESELECTED_PLAN(state, value) {
    state.wineClubPreselectedPlan = value
  },
  SET_MEMBERSHIP_TYPES(state, value) {
    state.membershipTypes = value
    state.membershipPlanSlugToName = value.reduce((mappedData, club) => {
      club.plans.forEach((plan) => {
        mappedData[plan.slug] = club.name
      })
      return mappedData
    }, {})
  },
  SET_PRODUCTS_TO_MEMBERSHIPS(state, value) {
    state.productsToMemberships = value
  },
}

const actions = {
  setWineClubPreselectedPlan({ commit }, value) {
    commit('SET_WINE_CLUB_PRESELECTED_PLAN', value)
  },
  async fetchMembershipTypes({ commit }) {
    try {
      commit(
        'SET_MEMBERSHIP_TYPES',
        (await this.$axios.get(`/api/membership/list/`)).data.results,
      )
    } catch (e) {
      this.$sentry.captureException(e)
      throw e
    }
  },
  async fetchProductsToMemberships({ commit }) {
    try {
      commit(
        'SET_PRODUCTS_TO_MEMBERSHIPS',
        (await this.$axios.get(`/api/membership/club-products/`)).data,
      )
    } catch (e) {
      this.$sentry.captureException(e)
      throw e
    }
  },
}

const getters = {
  wineClubPreselectedPlan: (state) => state.wineClubPreselectedPlan,
  membershipTypes: (state) => state.membershipTypes,
  productsToMemberships: (state) => state.productsToMemberships,
  membershipPlanSlugToName: (state) => state.membershipPlanSlugToName,
}

export default {
  state,
  mutations,
  actions,
  getters,
}
